"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertFileType = exports.FileTypeAlias = exports.FileType = void 0;
/**
 * 石墨文档类型
 */
var FileType;
(function (FileType) {
    /**
     * 传统文档
     */
    FileType["DocumentPro"] = "documentPro";
    /**
     * 轻文档
     */
    FileType["Document"] = "document";
    /**
     * 表格
     */
    FileType["Spreadsheet"] = "spreadsheet";
    /**
     * 专业幻灯片
     */
    FileType["Presentation"] = "presentation";
    /**
     * 应用表格
     */
    FileType["Table"] = "table";
    /**
     * 表单
     */
    FileType["Form"] = "form";
    /**
     * 流程图
     */
    FileType["Flowchart"] = "flowchart";
    /**
     * 思维导图
     */
    FileType["Mindmap"] = "mindmap";
    /**
     * 白板
     */
    FileType["Board"] = "board";
    /**
     * 未知类型
     */
    FileType["Unknown"] = "unknown";
})(FileType = exports.FileType || (exports.FileType = {}));
exports.FileTypeAlias = (_a = {},
    _a[FileType.Document] = 'docs',
    _a[FileType.DocumentPro] = 'docx',
    _a[FileType.Spreadsheet] = 'sheets',
    _a[FileType.Presentation] = 'presentation',
    _a[FileType.Table] = 'table',
    _a[FileType.Form] = 'form',
    _a[FileType.Mindmap] = 'mindmap',
    _a[FileType.Board] = 'board',
    _a[FileType.Flowchart] = 'flowchart',
    _a);
/**
 * 根据传入值转换为 FileType 枚举值
 */
function convertFileType(value) {
    var e_1, _a, e_2, _b;
    if (typeof value === 'string') {
        try {
            for (var _c = __values(Object.entries(FileType)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2), k = _e[0], v = _e[1];
                if (k === value || v === value) {
                    return v;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            for (var _f = __values(Object.entries(exports.FileTypeAlias)), _g = _f.next(); !_g.done; _g = _f.next()) {
                var _h = __read(_g.value, 2), k = _h[0], v = _h[1];
                if (v === value) {
                    return k;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    else {
        switch (value) {
            case -2:
                return FileType.Document;
            case -4:
                return FileType.Spreadsheet;
            case -6:
                return FileType.DocumentPro;
            case -7:
                return FileType.Mindmap;
            case -8:
                return FileType.Form;
            case -9:
                return FileType.Board;
            case -10:
                return FileType.Presentation;
            case -11:
                return FileType.Table;
            case -13:
                return FileType.Flowchart;
        }
    }
    return FileType.Unknown;
}
exports.convertFileType = convertFileType;
